export enum PaymentsAccountVerificationStatusDTO {
    NotRequired = 'NotRequired',
    Required = 'Required',
    PendingVerification = 'PendingVerification',
    Verified = 'Verified',
}

export class PaymentsAccountDetailsDTO {
    constructor(
        public chargesEnabled: boolean,
        public verificationStatus: PaymentsAccountVerificationStatusDTO | null = null,
        public accountSignupLink: string | null = null
    ) { }
}
